"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var context_1 = require("../../context");
/**
 * @deprecated
 */
var SnackbarProvider = function (_a) {
    var children = _a.children, render = _a.render;
    var _b = (0, react_1.useState)([]), messages = _b[0], setMessages = _b[1];
    var _c = (0, react_1.useState)(0), msgCounter = _c[0], setMsgCounter = _c[1];
    var snackbarContextValue = {
        messages: messages,
        push: function (message) {
            var counter = msgCounter + 1;
            setMsgCounter(counter);
            setMessages(__spreadArray(__spreadArray([], messages, true), [__assign({ id: "".concat(counter) }, message)], false));
        }
    };
    var removeMessage = (0, react_1.useCallback)(function (mid) {
        setMessages(messages.filter(function (m) { return m.id !== mid; }));
    }, [messages]);
    return (0, jsx_runtime_1.jsxs)(context_1.SnackbarContext.Provider, __assign({ value: snackbarContextValue }, { children: [children, messages.map(function (_a) {
                var id = _a.id, icon = _a.icon, text = _a.text, details = _a.details;
                return render({
                    text: text,
                    details: details,
                    icon: icon,
                    onRemove: function () { return removeMessage(id); }
                });
            })] }));
};
exports.SnackbarProvider = SnackbarProvider;
